// extracted by mini-css-extract-plugin
export default {"xl":"Logo_xl__JevGX","lg":"Logo_lg__Nf-vr","md":"Logo_md__fpAu6","sm":"Logo_sm__Zz4cF"};